import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import defaultIcon from "../../../../assets/VZY/defaultIcon.svg";

export const PopularTopicsBox = ({ popularTopic = [] }) => {
  const navigate = useNavigate();

  const formatCategoryForUrl = useCallback((value = "") => {
    return value
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");
  }, []);

  const handlePopularTopics = (topic) => {
    const slug = formatCategoryForUrl(topic?.contentCategoryName);
    navigate(`/VZYSupport/PopularTopics/${slug || "not-found"}`, {
      state: {
        detailsIDs: topic,
      },
    });
  };

  if (!Array.isArray(popularTopic) || popularTopic.length === 0) {
    return (
      <div className="no-record-found">
        <p>No popular topics found.</p>
      </div>
    );
  }

  return (
    <>
      {popularTopic.map((topic, index) => (
        <div
          className="popular-topics-col1"
          key={`${topic?.contentTypeID}-${index}`}
          onClick={() => handlePopularTopics(topic)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && handlePopularTopics(topic)}
        >
          <figure className="video-figure">
            <span>
              <img
                src={topic?.imageAndVideoUrl || defaultIcon}
                alt={topic?.contentTitle || "Popular Topic"}
                loading="lazy"
              />
            </span>
            <figcaption>{topic?.contentTitle || "-"}</figcaption>
          </figure>
          <p>{topic?.contentSubTitle || "-"}</p>
        </div>
      ))}
    </>
  );
};
